import { render, staticRenderFns } from "./AmazonBuild.vue?vue&type=template&id=a791c5ba&scoped=true&"
import script from "./AmazonBuild.vue?vue&type=script&lang=js&"
export * from "./AmazonBuild.vue?vue&type=script&lang=js&"
import style0 from "./AmazonBuild.vue?vue&type=style&index=0&id=a791c5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a791c5ba",
  null
  
)

export default component.exports